import './pages.css';
import { useLocation } from 'react-router-dom';
import DatePickerComponent from '../components/Filters/DatePicker';
import EnvironmentFilter from '../components/Filters/EnvironmentFilter';
import PackageFilter from '../components/Filters/PackageFilter';
import DailyOverview from '../components/Cards/DailyOverviewChart';
import LastSyncDisplay from '../components/LastSyncDisplay';
import React, { useState } from 'react';
import TestResultsTable from '../components/BrokenTestsTable/BrokenTestsTable';
import useFiltersData from '../hooks/useFiltersData';
import useLastSync from '../hooks/useLastSync';
import usePackages from '../hooks/usePackages';
import EmptyCard from '../components/Cards/EmptyCard';

function Filters({ selectedDate, setSelectedDate, selectedEnvironment, setSelectedEnvironment, selectedPackage, setSelectedPackage, lastSync, lastSyncLoading, availablePackages, packagesLoading }) {  
    return (
    <div className="filters-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
      <DatePickerComponent 
        selectedDate={selectedDate} 
        setSelectedDate={setSelectedDate} 
        maxDate={new Date()}
      />
      <EnvironmentFilter selectedEnvironment={selectedEnvironment} setSelectedEnvironment={setSelectedEnvironment} />
      <PackageFilter 
        selectedPackage={selectedPackage} 
        setSelectedPackage={setSelectedPackage} 
        availablePackages={availablePackages}
        loading={packagesLoading}
      />
      <LastSyncDisplay lastSync={lastSync} loading={lastSyncLoading} />
    </div>
  );
}

function Tag() {
  const [filters, setFilters] = useState({
    selectedDate: new Date(),
    selectedEnvironment: 'All Environments',
    selectedPackage: 'tag',
  });
  
  const location = useLocation();
  const setSelectedDate = (date) => setFilters(prev => ({ ...prev, selectedDate: date }));
  const setSelectedEnvironment = (env) => setFilters(prev => ({ ...prev, selectedEnvironment: env }));
  const setSelectedPackage = (pkg) => setFilters(prev => ({ ...prev, selectedPackage: pkg }));

  const oneWeek = 7 * 24 * 60 * 60 * 1000;
  const startDate = new Date(filters.selectedDate - oneWeek).toISOString().split('T')[0];
  const endDate = filters.selectedDate.toISOString().split('T')[0];

  const { data, loading, error } = useFiltersData(
    startDate,
    endDate,
    filters.selectedEnvironment, 
    filters.selectedPackage
  );

  const { data: lastSync, loading: lastSyncLoading }  = useLastSync(
    filters.selectedEnvironment, 
    filters.selectedPackage
  );

  const { data: availablePackages, loading: packagesLoading } = usePackages("tag");

  return (
    <div className="application-container table-owns-scroll">
      {location.pathname === '/tag' && (
        <>
          <Filters 
            selectedDate={filters.selectedDate} 
            setSelectedDate={setSelectedDate} 
            selectedEnvironment={filters.selectedEnvironment} 
            setSelectedEnvironment={setSelectedEnvironment} 
            selectedPackage={filters.selectedPackage} 
            setSelectedPackage={setSelectedPackage} 
            lastSync={lastSync}
            lastSyncLoading={lastSyncLoading}
            availablePackages={availablePackages}
            packagesLoading={packagesLoading}
          />
          <div className="flex-container">
            <div className="cards-container">
            <DailyOverview
                selectedDate={filters.selectedDate}
                selectedEnvironment={filters.selectedEnvironment}
                selectedPackage={filters.selectedPackage}
                data={data} // Pass data to DailyOverview
                loading={loading} // Pass loading state
                error={error} // Pass error state
              />
              <EmptyCard/>
              <EmptyCard/>
              <EmptyCard/>
            </div>
          </div>
          <TestResultsTable
            selectedDate={filters.selectedDate}
            selectedEnvironment={filters.selectedEnvironment}
            selectedPackage={filters.selectedPackage}
          />
        </>
      )}
    </div>
  );
}

export default Tag; 